<div class="container-fluid mt-3">

  <div *ngIf="cargando" class="loading-overlay">
    <div class="d-flex flex-column align-items-center">
        <div class="spinner-border text-primary mb-4" style="width: 5rem; height: 5rem;"></div>
        <h5 class="text-primary mb-1">Cargando tablero...</h5>
        <small class="text-muted">Un momento por favor</small>
    </div>
  </div>

  <!-- Contenido principal - solo se muestra cuando NO está cargando -->
  <div *ngIf="!cargando"><div *ngIf="cargando" class="loading-overlay">
    <div class="spinner-container">
      <div class="spinner-border text-primary" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
      <div class="mt-3 text-primary fw-bold fs-5">
        Cargando tablero...
      </div>
      <div class="text-muted small mt-2">Obteniendo datos del sistema</div>
    </div>
  </div>

  <!-- Contenido principal - solo se muestra cuando NO está cargando -->
  <div *ngIf="!cargando">
    <!-- Alertas -->
    <div *ngIf="alerts && alerts.length > 0">
        <div *ngFor="let alert of alerts" class="alert alert-warning" role="alert">
            <strong>⚠️ {{ alert.nombre }}:</strong> Stock mínimo {{ alert.stockMin }}, Stock actual {{ alert.stockActual
            }}
        </div>
    </div>


    <!-- Cards Día -->
    <div class="row">
        <div class="col-md-4" *ngFor="let stat of statsDay">
            <div class="card text-white mb-3" [ngClass]="stat.bgClass">
                <div class="card-body">
                    <h5 class="card-title"><i class="{{ stat.icon }}"></i> {{ stat.title }}</h5>
                    <p class="card-text">{{ stat.value | currency }}</p>
                    <small *ngIf="stat.percent">Var: {{ stat.percent }}%</small>
                </div>
            </div>
        </div>
    </div>

    <!-- Cards Mes -->
    <div class="row">
        <div class="col-md-4" *ngFor="let stat of statsMonth">
            <div class="card text-white mb-3" [ngClass]="stat.bgClass">
                <div class="card-body">
                    <h5 class="card-title"><i class="{{ stat.icon }}"></i> {{ stat.title }}</h5>
                    <p class="card-text">{{ stat.value | currency }}</p>
                    <small *ngIf="stat.percent">Var: {{ stat.percent }}%</small>
                </div>
            </div>
        </div>
    </div>

     <!-- Valorización de Stock - Sección especial -->
    <div class="row mt-4">
        <div class="col-md-4">
            <div class="card text-white mb-3 bg-warning shadow">
                <div class="card-body">
                    <h5 class="card-title"><i class="fas fa-hand-holding-usd"></i> Capital Invertido</h5>
                    <p class="card-text fs-4 fw-bold">
                        {{ stockValorizado.al_costo | currency:'ARS':'symbol-narrow':'1.0-0' }}
                    </p>
                    <small class="text-white-75">Valor al costo de compra (precioCom)</small>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="card text-white mb-3 bg-info shadow">
                <div class="card-body">
                    <h5 class="card-title"><i class="fas fa-tag"></i> Valor a Precio Lista</h5>
                    <p class="card-text fs-4 fw-bold">
                        {{ stockValorizado.a_precio_lista | currency:'ARS':'symbol-narrow':'1.0-0' }}
                    </p>
                    <small class="text-white-75">Si vendieras todo a precio de lista</small>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="card text-white mb-3 bg-success shadow" 
                [ngClass]="{'bg-danger': stockValorizado.margen_potencial < 0}">
                <div class="card-body">
                    <h5 class="card-title"><i class="fas fa-chart-line"></i> Margen Potencial</h5>
                    <p class="card-text fs-4 fw-bold">
                        {{ stockValorizado.margen_potencial | currency:'ARS':'symbol-narrow':'1.0-0' }}
                    </p>
                    <small class="text-white-75">
                        {{ stockValorizado.margen_porcentaje }} de margen bruto posible
                    </small>
                </div>
            </div>
        </div>
    </div>

    <!-- Resumen Anual -->
    <div class="card mb-3">
        <div class="card-header">📊 Resumen Anual</div>
        <div class="card-body">
            <ul class="list-group list-group-flush" *ngIf="statsYear.length">
                <li class="list-group-item" *ngFor="let y of statsYear">
                    <strong>{{ y.anio }}</strong>: Ventas {{ y.ventas | currency }}, Gastos {{ y.egresos | currency }},
                    Ganancias {{ y.ganancias | currency }}
                </li>
            </ul>
        </div>
    </div>

    <!-- Top Productos y Clientes -->
    <div class="row">
        <div class="col-md-6">
            <div class="card mb-3">
                <div class="card-header">🏆 Top Productos</div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" *ngFor="let p of topProducts">
                        {{ p.nombre }} - {{ p.total | number }}
                    </li>
                </ul>
            </div>
        </div>

        <div class="col-md-6">
            <div class="card mb-3">
                <div class="card-header">👥 Top Clientes</div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" *ngFor="let c of topClients">
                        {{ c.cliente }} - {{ c.total | currency }}
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <!-- Gráficos -->
    <!-- Gráficos -->
    <div class="row">
        <div class="col-md-6">
            <div class="card mb-3 shadow-sm">
                <div class="card-header bg-primary text-white">📈 Evolución de Ventas</div>
                <div class="card-body">
                    <canvas baseChart [data]="ventasChartData" [options]="chartOptions" [type]="'line'">
                    </canvas>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="card mb-3 shadow-sm">
                <div class="card-header bg-danger text-white">📉 Evolución de Gastos</div>
                <div class="card-body">
                    <canvas baseChart [data]="gastosChartData" [options]="chartOptions" [type]="'line'">
                    </canvas>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <div class="card mb-3 shadow-sm">
                <div class="card-header bg-danger text-white">📉 Evolución de Gastos</div>
                <div class="card-body">
                    <canvas baseChart [data]="comparativoChartData" [options]="comparativoChartOptions" [type]="'bar'">
                    </canvas>
                </div>
            </div>
        </div>
        <!-- Gráfico de Balance Mensual -->
        <div class="col-md-12">
            <div class="card mb-3 shadow-sm">
                <div class="card-header bg-warning text-dark">💹 Análisis de Balance Mensual (Ventas / Gastos)</div>
                <div class="card-body">
                    <canvas baseChart [data]="balanceChartData" [options]="balanceChartOptions" [type]="'bar'">
                    </canvas>
                </div>
            </div>
        </div>
    </div>
  </div>

</div>